module.exports = "/_next/static/images/BusinessPlan-sm@2x-a3d48a78112a453db54be3e7064a3491.webp";